import { render, staticRenderFns } from "./PopStartup.vue?vue&type=template&id=4dd293d5&lang=pug"
import script from "./PopStartup.vue?vue&type=script&lang=js"
export * from "./PopStartup.vue?vue&type=script&lang=js"
import style0 from "./PopStartup.vue?vue&type=style&index=0&id=4dd293d5&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports